//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from "vuex";
import AcBreadcrumbsItem from "@/components/Main/AppBreadcrumbs/ac-breadcrumbs-item.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

const checkClipping = (el) => el && (el.scrollWidth > el.clientWidth);
const sortEntries = (entry1, entry2) => entry1.label.localeCompare(entry2.label);
const replaceAll = (str, search, replacement) => str.split(search).join(replacement);

let orgValue = null;

export default {
    name: "AcBreadcrumbs",
    components: { AcBreadcrumbsItem, AQInput, AQTooltip },
    props: {
        path: { type: Array, required: true },
        type: { type: String, required: true },
        hybrid: { type: Boolean, default: false, required: false }
    },
    data() {
        return {
            keyRender: 0,
            filterText: null,
            showFilter: false,
            entries: [],
            showTooltip: false,
            showHeaderTooltip: false,
            isEditingHeader: false,
            maxElementNameLength: 100,
            previewMode: false,
            latestKeyPressed: {}
        };
    },
    computed: {
        ...mapState("components", ["appInterfaces", "activeInterface", "currentInterfaceProperties", "live"]),
        ...mapState("apps", ["processList"]),
        ...mapState("documentEditor", ["existingDocs", "selectedDoc"]),
        ...mapState("catalogs", ["items", "selectedCat"]),
        ...mapState("perspectiveBuilder", ["perspectivesList", "selectedPerspective", "searchPerspectiveData", "draftSelectedPerspective"]),
        ...mapGetters("dataStore", ["getEntityList", "getSelectedEntity"]),
        ...mapGetters("components", ["getCurrentInterface"]),
        ...mapGetters("apps", ["currentProcess", "currentApp"]),
        ...mapGetters("reports", ["getSelectedProcessReports", "getSelectedProcessStatistics"]),
        ...mapGetters("rules", ["showRuleTesting"]),
        isReadonly() {
            return this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
        },
        canRename() {
            return !!this.entityGuid && !this.isReadonly && this.$oneAtATime.state.$currentRoomEmpty && !this.previewMode;
        },
        isEdit() {
            return this.type === "edit";
        },
        localPath() {
            return this.isEdit ? this.parsedPath.slice(0, -1) : [...this.parsedPath];
        },
        parsedPath() {
            return this.path.map(item => {
                const { key, label, link, list } = item;

                return { link, list, label: key ? this.keyToLabel(key) : this.$t(label) };
            }).filter(item => item.label);
        },
        header() {
            this.$nextTick(this.checkHeaderEllipsis);

            return this.parsedPath.slice(-1)[0].label;
        },
        hasList() {
            return this.parsedPath.length ? this.parsedPath.slice(-1)[0].list : false;
        },
        hasListAndNotLive() {
            return this.hasList && !this.live;
        },
        filteredEntries() {
            const lowerFilter = (this.filterText || "").toLowerCase();
            return this.filterText ? this.entries.filter(({ label }) => label.toLowerCase().includes(lowerFilter)) : this.entries;
        },
        entityName() {
            const { name } = this.$route || {};

            const entityMapping = {
                userInterfaces: "interfaces",
                process: "processes",
                documents: "documents",
                dataStore: "dataStore",
                catalogs: "catalogs",
                perspectiveBuilder: "perspectives",
                search: "searchPerspectives"
            };

            return entityMapping[name];
        },
        entityGuid() {
            let currentGuid = null;

            if (this.entityName === "interfaces") {
                currentGuid = this.activeInterface;
            } else if (this.entityName === "processes") {
                currentGuid = this.currentProcess.id;
            } else if (this.entityName === "documents") {
                currentGuid = this.selectedDoc.length ? this.selectedDoc[0].id : null;
            } else if (this.entityName === "dataStore") {
                currentGuid = this.getSelectedEntity.name ? this.getSelectedEntity.code : null;
            } else if (this.entityName === "catalogs") {
                currentGuid = this.selectedCat.id;
            } else if (this.entityName === "perspectives") {
                currentGuid = this.selectedPerspective.id;
            } else if (this.entityName === "searchPerspectives") {
                currentGuid = this.searchPerspectiveData.id;
            }

            return currentGuid;
        }
    },
    mounted() {
        this.$root.$on("previewSaveHistoryLoadEnd", routeName => {
            if (routeName === "userInterfaces" || routeName === "documents") {
                this.previewMode = true;
            }
        });
        this.$root.$on("previewSaveHistoryClose", routeName => {
            if (routeName === "userInterfaces" || routeName === "documents") {
                this.previewMode = false;
            }
        });
        this.$root.$on("confirmRestore", routeName => {
            if (routeName === "userInterfaces" || routeName === "documents") {
                this.previewMode = false;
            }
        });
        this.$root.$on("previewMode", routeName => {
            if (routeName === "userInterfaces" || routeName === "documents") {
                this.previewMode = false;
            }
        });
    },
    methods: {
        ...mapActions("components", ["renameInterface"]),
        keyToLabel(key) {
            let label = "";

            if (key === "currentAppName") {
                label = this.currentApp.name;
            } else if (key === "currentInterface") {
                label = this.getCurrentInterface;
            } else if (key === "currentProcess") {
                label = this.currentProcess.name;
            } else if (key === "currentDocument") {
                label = this.selectedDoc.length ? this.selectedDoc[0].name : null;
            } else if (key === "selectedEntity") {
                label = this.getSelectedEntity.name ? this.getSelectedEntity.name : null;
            } else if (key === "currentCatalog") {
                label = this.selectedCat.name;
            } else if (key === "currentPerspective") {
                label = this.draftSelectedPerspective.name || this.selectedPerspective.name;
            } else if (key === "currentSearchPerspective") {
                label = this.searchPerspectiveData.name;
            } else if (key === "currentStatistic") {
                label = this.getSelectedProcessStatistics.name;
            } else if (key === "currentProcessData") {
                label = this.getSelectedProcessReports.reports.name;
            }

            return label;
        },
        onClickEntry(entry) {
            const { id: guid } = entry;
            if (guid === this.entityGuid) { return; }

            const evName = `bc__${this.entityName}__open`;

            this.showFilter = false;
            this.previewMode = false;
            this.keyRender += 1;

            this.$emit("open", { ev: evName, guid });
        },
        isCurrent(item) {
            return item.id === this.entityGuid;
        },
        beforeShow() {
            if (this.entityName === "interfaces") {
                this.entries = (this.appInterfaces || []).filter(app => app.id).map(({ id, name }) => ({ id, label: name })).sort(sortEntries);
            } else if (this.entityName === "processes") {
                this.entries = (this.processList || []).map(({ id, name }) => ({ id, label: name })).sort(sortEntries);
            } else if (this.entityName === "documents") {
                this.entries = (this.existingDocs || []).map(({ id, name }) => ({ id, label: name })).sort(sortEntries);
            } else if (this.entityName === "dataStore") {
                this.entries = (this.getEntityList || []).map(({ code, name }) => ({ id: code, label: name })).sort(sortEntries);
            } else if (this.entityName === "catalogs") {
                this.entries = (this.items || []).map(({ id, name }) => ({ id, label: name })).sort(sortEntries);
            } else if (this.entityName === "perspectives" || this.entityName === "searchPerspectives") {
                this.entries = (this.perspectivesList || []).map(({ id, name }) => ({ id, label: name })).sort(sortEntries);
            } else {
                this.entries = [];
            }
        },
        startEdit() {
            const availableEntityNameList = ["interfaces", "processes", "documents", "dataStore"];
            if (this.canRename && !this.isEditingHeader && availableEntityNameList.includes(this.entityName)) {
                const { header } = this.$refs;
                const { headerWrap } = this.$refs;
                orgValue = (header.innerText || "").trim().replace(/\n|\r/g, "");
                this.isEditingHeader = true;
                this.showHeaderTooltip = false;

                this.$nextTick(() => {
                    header.contentEditable = "true";
                    header.addEventListener("blur", this.onBlurEvent);
                    headerWrap.classList.remove("ellipsis-mode");
                    header.focus();
                });
            }
        },
        onPaste(event) {
            event.preventDefault();
            let text = (event.originalEvent || event).clipboardData.getData("text/plain");

            text = replaceAll(text, "\r\n", " ");
            text = replaceAll(text, "\n", " ");
            text = replaceAll(text, "\r", " ");

            window.document.execCommand("insertText", false, text);

            const { header } = this.$refs;
            if (header.innerText.length > this.maxElementNameLength) {
                header.innerText = header.innerText.slice(0, this.maxElementNameLength);
            }
        },
        onKeydown(event) {
            const { header } = this.$refs;
            const currentVal = (header.innerText || "").trim().replace(/\n|\r/g, "");
            this.latestKeyPressed[event.key] = true;
            const allowedKeys = new Set(["Enter", "Escape", "Backspace", "Delete", "Control", "Home", "End", "ArrowLeft", "ArrowRight"]);
            const allowedComboKeys = new Set(["a", "c", "v", "x"]);
            if (currentVal.length >= this.maxElementNameLength
                && !allowedKeys.has(event.key)
                && !(this.latestKeyPressed.Control && allowedComboKeys.has(event.key))) {
                event.preventDefault();
            } else if (event.key === "Escape") {
                header.innerText = orgValue;
                this.stopEdit();
            } else if (event.key === "Enter") {
                this.onBlurEvent(event);
            }
        },
        onKeyUp(event) {
            if (this.latestKeyPressed[event.key]) {
                delete this.latestKeyPressed[event.key];
            }
        },
        onBlurEvent(event) {
            const { header } = this.$refs;
            header.innerText = (header.innerText || "").trim();
            this.stopEdit(true);
            event.preventDefault();
        },
        stopEdit(emit) {
            const { header } = this.$refs;
            const { headerWrap } = this.$refs;
            header.parentElement.scrollTo({ left: 0 });
            this.nonEditableContent();
            headerWrap.classList.add("ellipsis-mode");
            this.keyRender += 1;
            if (emit && header.innerText.length <= this.maxElementNameLength && header.innerText !== orgValue) {
                const [last] = this.path.slice(-1);
                this.$root.$emit(`bc__${last.key}__rename`, { newName: header.innerText, oldName: orgValue });
            }
        },
        checkHeaderEllipsis() {
            const { header } = this.$refs;
            this.showHeaderTooltip = checkClipping(header);
        },
        checkForEllipsis(event) {
            const el = event.target.querySelector(".entry__content");
            this.showTooltip = checkClipping(el);
        },
        showOptionsList() {
            this.showFilter = !this.showFilter;
        },
        hideFilter() {
            this.showFilter = false;
            this.$nextTick(() => { this.filterText = null; });
        },
        goTo(link) {
            const exceptionList = ["/applications", "/dataStore/dataTablesLegacy", "/dataStore/dataTables"];
            const checkAppRoute = () => (exceptionList.includes(link) ? link : `/applications/${this.currentApp.id}${link}`);
            this.$emit("goTo", checkAppRoute());
        },
        nonEditableContent() {
            const { header } = this.$refs;
            header.removeEventListener("blur", this.onBlurEvent);
            header.contentEditable = "false";
            this.isEditingHeader = false;
        }
    }
};
